import React from 'react';

export default ({ children, form=false, t, login, ...props}) => <div className={`zt-bankid ${form ? 'zt-bankid--form' : ''}`}>
  <h4 className='zt-bankid__label'>{login ? t('coreid.login.label', 'Authorisation using BankID') : t('coreid.label', 'Registration with BankID')}</h4>
  {children}
</div>
